export const registerServiceWorker = ({ onUpdate } = {}) => {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return Promise.resolve(null);
  }

  return navigator.serviceWorker
    .register('/service-worker.js', { updateViaCache: 'none' })
    .then((registration) => {
      if (registration.waiting && navigator.serviceWorker.controller) {
        onUpdate?.(registration.waiting);
      }

      registration.addEventListener('updatefound', () => {
        const worker = registration.installing;
        if (!worker) return;

        worker.addEventListener('statechange', () => {
          if (worker.state === 'installed' && navigator.serviceWorker.controller) {
            onUpdate?.(worker);
          }
        });
      });

      registration.update().catch(() => {});
      return registration;
    })
    .catch((error) => {
      console.warn('[pwa] Не удалось зарегистрировать service worker:', error);
      return null;
    });
};
